<span class="flex align-items-center gap-2 w-full">
  <span class="font-bold white-space-nowrap text-lg"
    >{{ designator }}
    <p-button
      [styleClass]="'w-1-5rem h-1-5rem p-1'"
      *ngIf="TYPES.indexOf(type) === -1"
      icon="pi pi-clone"
      [rounded]="true"
      [text]="true"
      (click)="copyDesignator($event, designator)"
    ></p-button>
  </span>
  <div *ngIf="serviceAndFrequency.length">
    <span class="rqa-badge" *ngFor="let item of serviceAndFrequency">{{ item }}</span>
  </div>
</span>
<span class="flex align-items-center gap-2 w-full text-sm">{{ name }}</span>
